import React, { useContext } from 'react';
import { Paper, Typography, IconButton } from '@mui/material';
import { ThemeContext } from 'styled-components';

const SectionHeader = ({ title, actionButton, onActionClick, borderRadius = '16px 16px 0 0', margin }) => {
    const theme = useContext(ThemeContext);
    // Default margin is responsive: no negative margin on small screens
    const defaultMargin = margin !== undefined ? margin : { xs: 0, sm: '0 -10px 0 -10px' };
    // Make border radius responsive - no radius on small screens to match parent container
    const responsiveBorderRadius = typeof borderRadius === 'string' 
        ? { xs: 0, sm: borderRadius }
        : borderRadius;

    return (
        <Paper sx={{
            padding: 2,
            margin: defaultMargin,
            borderRadius: responsiveBorderRadius,
            borderColor: theme.colors.headerBorder,
            borderStyle: 'solid',
            backgroundColor: theme.colors.primary, // Use backgroundColor instead of background
            backgroundImage: 'none', // Ensure no default Paper background
            color: theme.colors.secondary,
            borderWidth: '2',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            boxSizing: 'border-box',
            width: { xs: '100%', sm: 'calc(100% + 20px)' },
            overflow: 'visible', // Allow button to be clickable
            pointerEvents: 'auto', // Ensure clicks work
        }}>
            <Typography variant="h6" sx={{
                fontWeight: "bold",
                textAlign: 'center',
            }}>{title}</Typography>
            {actionButton && onActionClick && (
                <IconButton
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (onActionClick) {
                            onActionClick(e);
                        }
                    }}
                    sx={{
                        color: theme.colors.secondary,
                        position: 'absolute',
                        right: 8,
                        zIndex: 10,
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                >
                    {actionButton}
                </IconButton>
            )}
        </Paper>
    );
};

export default SectionHeader;
